import { gql } from '@apollo/client';
import { ACCOUNT_DATA_V2 } from './accountFragment';

export const USER_DATA_V2 = gql`
    fragment userFieldsV2 on Customer {
        contact {
            id
            salutation
            userName
            firstName
            lastName
            email
            onlineShopAccess
            fax
            title
            createdAt
            academicTitle
            function
            mobilePhone
            featureAccess {
                feature {
                    id
                    name
                    value
                    amountValue
                    valueText
                }
            }
        }
        accounts {
            ...accountFieldsV2
        }
        activeAccount {
            ...accountFieldsV2
        }
    }
    ${ACCOUNT_DATA_V2}
`;
